module.exports = require("./lib/index.js").default



//////////////////
// WEBPACK FOOTER
// ./node_modules/historykana/index.js
// module id = 394
// module chunks = 0